module.exports = __webpack_public_path__ + "media/images/ns-app-battery-icon-100-573d3b6900d82b4ec99d7df471b2b02e.svg";